import { Component, inject, OnInit, signal } from '@angular/core';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { confirmSignIn } from '@aws-amplify/auth';
import { UntilDestroy } from '@ngneat/until-destroy';
import { UserStoreService } from '../../store/user';
import { AuthStoreService } from '../../store/auth';
import { TranslocoService } from '@jsverse/transloco';

@UntilDestroy()
@Component({
  selector: 'rmb-mfa-confirmation',
  templateUrl: './mfa-confirmation.component.html',
  styleUrls: ['./mfa-confirmation.component.scss'],
  standalone: false,
})
export class MfaConfirmationComponent implements OnInit {
  private router = inject(Router);
  private translocoService = inject(TranslocoService);
  private authStoreService = inject(AuthStoreService);
  private userStoreService = inject(UserStoreService);

  readonly TRANSLOCO_PREFIX = 'auth.login.mfa.';
  registrationEmail: string;
  codeForm: FormGroup = new FormGroup({
    code: new FormControl<string>('', [Validators.required]),
  });
  errorMessage: string;
  readonly loading = signal(false);

  async ngOnInit(): Promise<void> {
    this.registrationEmail = this.userStoreService.getUserQuery().getUserEmail();
    if (!this.registrationEmail) {
      console.error('Cannot Verify user without email.');
      await this.router.navigate(['/auth', 'login']);
    }
  }

  async onCodeSubmit(): Promise<void> {
    if (this.codeForm.invalid) {
      return;
    }
    this.errorMessage = '';
    this.loading.set(true);

    try {
      await confirmSignIn({
        challengeResponse: this.codeForm.value.code.trim(),
      });

      const attributes = await this.authStoreService.updateSessionState();
      this.userStoreService.updateUserAttributes(attributes);
      await this.authStoreService.redirectAfterLogin(this.router, this.userStoreService.getUserQuery().getInvitationKey());
    } catch (err) {
      this.errorMessage = this.translocoService.translate('auth.errors.' + err.name);
    } finally {
      this.loading.set(false);
    }
  }
}
